import React from 'react';
import { motion } from 'framer-motion';
import { usePrefersReducedMotion } from './motion';
type LeadCard = {
  name: string;
  job: string;
  time: string;
};
const columns: {
  label: string;
  cards: LeadCard[];
}[] = [{
  label: 'New lead',
  cards: [{
    name: 'J. Alvarez',
    job: 'Sink leak',
    time: '2m ago'
  }, {
    name: 'D. Chen',
    job: 'AC tune-up',
    time: '18m ago'
  }]
}, {
  label: 'Estimate sent',
  cards: [{
    name: 'T. Ramirez',
    job: 'Roof repair',
    time: '1h ago'
  }]
}, {
  label: 'Scheduled',
  cards: [{
    name: 'M. Osei',
    job: 'Full remodel',
    time: 'Tue 2:00p'
  }]
}, {
  label: 'Done',
  cards: [{
    name: 'K. Patel',
    job: 'Drain cleaning',
    time: 'Yesterday'
  }]
}];

/* The CRM's actual pipeline, mocked with plausible job types instead of the
   generic "task board" every SaaS screenshot uses -- this is what "every
   lead and job in one place" (the section's own copy) looks like, not just
   says. Real column names match how a job actually moves; the new-lead
   column pulses to suggest live intake, matching LeadFlowVisual's animated
   motif elsewhere on the site. Entrance is a staggered whileInView reveal,
   not a continuous loop, so the one continuous element (the intake pulse)
   is the only thing gated behind reduced-motion. */
export function PipelineBoardVisual() {
  const reducedMotion = usePrefersReducedMotion();
  return <div className="w-full overflow-x-auto" data-id="element-791" data-mp="1ewzvli2wrtar">
      <div className="grid min-w-[640px] grid-cols-4 gap-3 rounded-2xl border border-[#1c1c1c] bg-[#0a0a0a] p-4" data-id="element-792" data-mp="1ew6xt6lxge4r">
        {columns.map((col, ci) => <motion.div key={col.label} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        delay: ci * 0.08
      }} data-id="element-793" data-mp="15xd3xnzze1uw" data-mpi={ci}>
            <div className="flex items-center gap-2 px-1 pb-3" data-id="element-794" data-mp="w103m79xkpr6">
              {ci === 0 && <span className="relative flex h-1.5 w-1.5" aria-hidden="true" data-id="element-795" data-mp="10zl1i01pmxcg">
                  {!reducedMotion && <motion.span className="absolute inset-0 rounded-full bg-emerald-500" animate={{
              scale: [1, 2.4],
              opacity: [0.6, 0]
            }} transition={{
              duration: 1.8,
              repeat: Infinity,
              ease: 'easeOut'
            }} data-id="element-796" data-mp="2xwfxxr14ujlq" />}
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" data-id="element-797" data-mp="3lm1x4ehi8ytq" />
                </span>}
              <p className="font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-500" data-id="element-798" data-mp="3hl89znbvzo1w">
                {col.label}
              </p>
              <span className="ml-auto font-mono text-[10px] text-neutral-700" data-id="element-799" data-mp="3cmwzdadrp9im">
                {col.cards.length}
              </span>
            </div>
            <div className="space-y-2" data-id="element-800" data-mp="216yiwlg9fl7d">
              {col.cards.map((card, i) => <motion.div key={card.name} initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.35,
            delay: ci * 0.08 + i * 0.06 + 0.1
          }} className="rounded-lg border border-[#1c1c1c] bg-[#111111] p-3" data-id="element-801" data-mp="1w6km5zk3zxon" data-mpi={i}>
                  <p className="text-xs font-semibold text-neutral-200" data-id="element-802" data-mp="20suyifc4vhoh">{card.name}</p>
                  <p className="mt-0.5 text-[11px] text-neutral-500" data-id="element-803" data-mp="24u6hi20i54np">{card.job}</p>
                  <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.1em] text-neutral-700" data-id="element-804" data-mp="29s7zskq3szy4">
                    {card.time}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>)}
      </div>
    </div>;
}